module.exports = __webpack_public_path__ + "static/countdown-to-zero-day-6874447b900070896db8476f78af1ab6.jpg";